let mediaUploader: any; // wp.media doesn't have TypeScript support, so 'any' is used

export function initializeMediaUpload(uploadButton: HTMLElement) {
    const closestUploadBox = uploadButton.closest('.media-upload-box') as HTMLElement | null;

    if (mediaUploader) {
        mediaUploader.open();
        return;
    }

    mediaUploader = wp.media({
        title: 'Choose Image',
        button: {
            text: 'Use this image'
        },
        multiple: false
    });

    mediaUploader.on('select', () => {
        const attachment = mediaUploader.state().get('selection').first().toJSON();

        const imageIdField = closestUploadBox?.querySelector('.image_id') as HTMLInputElement;
        const imagePreviewField = closestUploadBox?.querySelector('.image-preview');

        if (imageIdField) imageIdField.value = attachment.id;
        if (imagePreviewField) {
            imagePreviewField.innerHTML = `<img src="${attachment.url}" style="max-width: 100%; height: auto;" />`;
        }
    });

    mediaUploader.open();
}
